"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hash_1 = __importDefault(require("@emotion/hash"));
const get_safe_value_1 = __importDefault(require("./get-safe-value"));
/**
 * Generates the class name.
 */
function getClassName(propertyInfo, value) {
    const { className, safeValue = false, // Value never contains unsafe characters. e.g: 10, hidden, border-box
    complexValue = false // Complex values that are best hashed. e.g: background-image
     } = propertyInfo;
    let valueKey;
    // Shortcut the global keywords
    if (value === 'inherit' || value === 'initial' || value === 'unset') {
        valueKey = value;
        /* Always hash values that contain a calc() because the operators get
        stripped which can result in class name collisions
        */
    }
    else if (complexValue || value.includes('calc(')) {
        valueKey = hash_1.default(value);
    }
    else if (safeValue) {
        valueKey = value;
    }
    else {
        valueKey = get_safe_value_1.default(value);
    }
    return `ub-${className}_${valueKey}`;
}
exports.default = getClassName;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LWNsYXNzLW5hbWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZ2V0LWNsYXNzLW5hbWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSx5REFBZ0M7QUFDaEMsc0VBQTJDO0FBVzNDOztHQUVHO0FBQ0gsU0FBd0IsWUFBWSxDQUFDLFlBQTBCLEVBQUUsS0FBYTtJQUM1RSxNQUFNLEVBQ0osU0FBUyxFQUNULFNBQVMsR0FBRyxLQUFLLEVBQUUsc0VBQXNFO0lBQ3pGLFlBQVksR0FBRyxLQUFLLENBQUMsNkRBQTZEO01BQ25GLEdBQUcsWUFBWSxDQUFBO0lBQ2hCLElBQUksUUFBZ0IsQ0FBQTtJQUVwQiwrQkFBK0I7SUFDL0IsSUFBSSxLQUFLLEtBQUssU0FBUyxJQUFJLEtBQUssS0FBSyxTQUFTLElBQUksS0FBSyxLQUFLLE9BQU8sRUFBRTtRQUNuRSxRQUFRLEdBQUcsS0FBSyxDQUFBO1FBQ2hCOztVQUVFO0tBQ0g7U0FBTSxJQUFJLFlBQVksSUFBSSxLQUFLLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxFQUFFO1FBQ2xELFFBQVEsR0FBRyxjQUFJLENBQUMsS0FBSyxDQUFDLENBQUE7S0FDdkI7U0FBTSxJQUFJLFNBQVMsRUFBRTtRQUNwQixRQUFRLEdBQUcsS0FBSyxDQUFBO0tBQ2pCO1NBQU07UUFDTCxRQUFRLEdBQUcsd0JBQVksQ0FBQyxLQUFLLENBQUMsQ0FBQTtLQUMvQjtJQUVELE9BQU8sTUFBTSxTQUFTLElBQUksUUFBUSxFQUFFLENBQUE7QUFDdEMsQ0FBQztBQXZCRCwrQkF1QkMifQ==